import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for TeamsChannelStore, for use in the registry */ export const TeamsChannelStoreActionTypes = [
    ActionType.FetchTeamsChannelAction,
    ActionType.FetchTeamsChannelSucceededAction,
    ActionType.FetchTeamsChannelFailedAction,
    ActionType.FetchEntityCollectionAction,
    ActionType.FetchEntityCollectionSucceededAction,
    ActionType.FetchEntityCollectionFailedAction,
    ActionType.FetchTeamsChannelFilesFolderAction,
    ActionType.FetchTeamsChannelFilesFolderSucceededAction,
    ActionType.FetchTeamsChannelFilesFolderFailedAction
];
